export default "__VITE_ASSET__BN97QbXJ__"